import type { TableColumns } from '@ohpen/enso-ui';
import { BaseRateResponse, FieldType, InterestRateRequest, InterestRate } from '@pmp/api';

export const baseRateColumns: TableColumns<BaseRateResponse> = [
  {
    title: 'pmp.baseRates.labels.baseRateName',
    dataIndex: 'name',
    key: 'name',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.baseRateId',
    dataIndex: 'code',
    key: 'code',
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'rate',
    key: 'rate',
    options: {
      format: {
        type: 'percentage',
        decimalScale: 4,
      },
      filter: 'number',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.variabilityType',
    dataIndex: 'variabilityType',
    key: 'variabilityType',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.VARIABILITY_TYPE,
      sorter: true,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const historicColumns: TableColumns<InterestRate> = [
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    key: 'rate',
    options: {
      format: {
        type: 'percentage',
        decimalScale: 4,
      },
      filter: 'number',
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
    },
  },
  {
    title: 'pmp.baseRates.labels.endDate',
    dataIndex: 'endDate',
    key: 'endDate',
    options: {
      filter: 'date',
    },
  },
  {
    title: 'pmp.baseRates.labels.index',
    dataIndex: 'index',
    key: 'index',
    options: {
      filter: 'number',
      sorter: true,
    },
  },
  { title: 'global.labels.actions', dataIndex: '', key: 'actions', width: 100, fixed: 'right' },
];

export const baseRateChangeColumns: TableColumns<BaseRateResponse> = [
  {
    title: 'pmp.baseRates.labels.baseRateName',
    dataIndex: 'name',
    key: 'name',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.baseRateId',
    dataIndex: 'code',
    key: 'code',
    options: {
      filter: 'search',
      sorter: true,
      hide: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    key: 'amount',
    options: {
      format: {
        type: 'percentage',
        decimalScale: 4,
      },
      filter: 'number',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.variabilityType',
    dataIndex: 'variabilityType',
    key: 'variabilityType',
    options: {
      format: {
        type: 'valueList',
      },
      filter: 'select',
      listName: FieldType.VARIABILITY_TYPE,
      sorter: true,
    },
  },
];

export const interestRateColumns: TableColumns<InterestRateRequest> = [
  {
    title: 'pmp.baseRates.labels.baseRateCode',
    dataIndex: 'baseRateCode',
    key: 'baseRateCode',
    options: {
      filter: 'search',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.rate',
    dataIndex: 'amount',
    key: 'amount',
    options: {
      format: {
        type: 'percentage',
        decimalScale: 4,
      },
      filter: 'number',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.startDate',
    dataIndex: 'startDate',
    key: 'startDate',
    options: {
      filter: 'date',
      sorter: true,
    },
  },
  {
    title: 'pmp.baseRates.labels.index',
    dataIndex: 'index',
    key: 'index',
    options: {
      filter: 'number',
      sorter: true,
    },
  },
];
